// @ts-nocheck
import { useMediaQuery } from "@mui/material";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
// import useMediaQuery from "@mui/material/useMediaQuery";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import XomeLogo from "../../assets/xome-logo-blaze.png";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "../../services/AuthContext";
const theme = createTheme();

const dummyUsers = {
  "sanju@user.com": { password: "1234", investorId: 3, username: 'Sanju' },
  "guru@user.com": { password: "1234", investorId: 4, username: 'Guru' },
  "santosh@user.com": { password: "1234", investorId: 5, username: 'Santosh' },
  "srikanth@user.com": { password: "1234", investorId: 6, username: 'Srikanth' },
  // Add more users as needed
};

const LoginPage = () => {
  const count = useSelector((state) => state.user.value)
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const { setInvestorId } = useAuth(); 
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));


  const handleLogin = (e) => {
    e.preventDefault();
    const email = e.target.email.value;
    const password = e.target.password.value;
  
    const user = dummyUsers[email]; // Assume this is defined
  
    if (user && user.password === password) {
      setInvestorId({investorId :  user.investorId, username: user.username}); // Set the investor ID in state
      localStorage.setItem('investorId', user.investorId); // Save to local storage
      localStorage.setItem('email', email); // Save to local storage
      localStorage.setItem('investorName', user.username); // Save to local storage
      console.log("Investor ID set:", {id:  user.investorId, username: user.username });
      navigate("/"); // Navigate to the desired route
    } else {
      alert("Invalid email or password.");
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: "flex",
          minHeight: "100vh",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: { xs: "center", xl: "normal" },
          backgroundColor: "#F8F8F8",
        }}
      >
        {isDesktop && (
          <Box
            sx={{
              width: "50%",
              p: 10,
              display: "flex",
              flexDirection: "column",
            }}
          ></Box>
        )}

        <Box
          sx={{
            width: { xs: "100%", md: "50%" },
            backgroundColor: "#fff",
            p: { xs: 2, sm: 10 },
            pt: { xs: 5, sm: 5 },
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh",
          }}
        >
          <Box sx={{ mb: 4 }}>
            <img
              src={XomeLogo}
              alt="Xome Logo"
              style={{ height: "50px", marginBottom: "10px", margin: "0 auto" }}
            />
            <Typography textAlign={"center"} sx={{ fontWeight: "bold", color: "#FF5C39" }}>
              There’s No Place Like Xome
            </Typography>
            <hr style={{ borderTop: "2px solid #d1d5db", margin: "20px 0" }} />
            <Typography variant="h6" textAlign={"center"} sx={{ fontWeight: "bold" }}>
              Sign In
            </Typography>
            <Typography sx={{ color: "#3B3B3B", fontSize: "14px" }}>
              Sign in to unlock live remote bidding, participate in multiple auctions, and manage your funds online. Don't have an account?{" "}
              <Link to="/signup" style={{ color: "#f97316" }}>Sign up.</Link>
            </Typography>
          </Box>
          
          <form onSubmit={handleLogin}>
            <TextField
              label="Email Address"
              name="email"
              fullWidth
              size="small"
              sx={{ mb: 2 }}
            />
            <TextField
              label="Password"
              type="password"
              name="password"
              fullWidth
              size="small"
              sx={{ mb: 2 }}
            />
            <Button
              type="submit"
              variant="contained"
              sx={{
                backgroundColor: "#FF5C39",
                "&:hover": { backgroundColor: "#FF5C39" },
                py: 1,
                display: "block",
                mx: "auto",
              }}
            >
              Sign in
            </Button>
            <Typography sx={{ color: "#3B3B3B", fontSize: "12px", mt: 1 }}>
              Don't remember your login details?{" "}
              <a target="_blank" href="#" style={{ color: "#FF5C39" }}>Get help signing in.</a>
            </Typography>
          </form>
          <Typography sx={{ color: "#3B3B3B", fontSize: "14px", mt: 3 }}>
            Note: Your login credentials on this platform may be different from that of Xome.com
          </Typography>
          <Typography sx={{ color: "#6b7280", fontSize: "12px", backgroundColor: "#FCF8E3", p: 1, my: 0.5 }}>
            By providing your information you hereby agree that you are not a resident of the European Union nor are you present in the European Union at the time of your submission.
          </Typography>
          <Typography sx={{ color: "#6b7280", fontSize: "12px" }}>
            I accept the{" "}
            <a target="_blank" href="https://www.xome.com/pages/terms-of-use" style={{ color: "#FF5C39" }}>Terms of Use</a>,{" "}
            <a target="_blank" href="https://www.xome.com/pages/privacy-policy" style={{ color: "#FF5C39" }}>Privacy Policy</a>, and{" "}
            <a target="_blank" href="https://www.xome.com/auctions/auction-eventagreement" style={{ color: "#FF5C39" }}>Auction Participation Agreement</a>.
          </Typography>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default LoginPage;

